<template>
  <div class="q-progress">
    <div class="q-progress-track" :style="trackStyle">&nbsp;</div>
    <div v-if="buffer" class="q-progress-buffer" :style="bufferStyle">&nbsp;</div>
    <div class="q-progress-model" :style="modelStyle">&nbsp;</div>
  </div>
</template>

<script>
function width (val) {
  return {width: `${val}%`}
}
function between (val, min, max) {
  return Math.min(max, Math.max(min, val))
}
export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    buffer: Number
  },
  computed: {
    model () {
      return between(this.percentage, 0, 100)
    },
    bufferModel () {
      return between(this.buffer || 0, 0, 100 - this.model)
    },
    modelStyle () {
      return width(this.model)
    },
    bufferStyle () {
      return width(this.bufferModel)
    },
    trackStyle () {
      return width(this.buffer ? 100 - this.buffer : 100)
    }
  }
}
</script>
<style>
.q-progress {
  position: relative;
  height: 4px;
  display: block;
  width: 100%;
  border-radius: 2px;
  background-clip: padding-box;
  margin: 0.5rem 0 1rem 0;
  overflow: hidden;
}
.q-progress:not(.indeterminate) .q-progress-model {
  position: absolute;
  top: 0;
  bottom: 0;
  background: #027be3;
  border-radius: 2px;
  transition: width 0.3s linear;
}
.q-progress.animate .q-progress-model {
  -webkit-animation: q-progress-stripes 2s linear infinite;
          animation: q-progress-stripes 2s linear infinite;
}
.q-progress.indeterminate .q-progress-buffer {
  display: none;
}
.q-progress.indeterminate .q-progress-model {
  background: #027be3;
}
.q-progress.indeterminate .q-progress-model:before,
.q-progress.indeterminate .q-progress-model:after {
  content: '';
  position: absolute;
  background: inherit;
  top: 0;
  left: 0;
  bottom: 0;
  will-change: left, right;
}
.q-progress.indeterminate .q-progress-model:before {
  -webkit-animation: q-progress-indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
          animation: q-progress-indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
}
.q-progress.indeterminate .q-progress-model:after {
  -webkit-animation: q-progress-indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
          animation: q-progress-indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
  -webkit-animation-delay: 1.15s;
          animation-delay: 1.15s;
}
.q-progress.stripe .q-progress-model,
.q-progress.stripe .q-progress-model:before,
.q-progress.stripe .q-progress-model:after {
  background-image: linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);
  background-size: 40px 40px;
}
.q-progress.primary .q-progress-model {
  background-color: #027be3;
}
</style>
